<template>
  <div class="zhanwei4"></div>
  <div class="next">
    <h1>{{ $t("edit.cover.title") }}</h1>
    <div class="btns">
      <el-button
        size="large"
        @click="handleSave"
        style="background: #4f4f4f; color: #fff"
      >
        {{ $t("edit.cover.save") }}</el-button
      >
    </div>
  </div>
  <div class="zhanwei4"></div>
  <div class="coverSetting">
    <div class="coverSetting_left">
      <el-form
        :model="form"
        label-width="auto"
        style="max-width: 600px"
        label-position="top"
      >
        <el-form-item :label="$t('edit.cover.gameTitle')">
          <el-input v-model="form.gameTitle" size="large" />
        </el-form-item>
        <el-form-item label="游戏创作者">
          <el-input v-model="form.author" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.opening_hours')">
          <el-input v-model="form.openHour" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.experience_time')">
          <el-input v-model="form.experienceTime" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.begin')">
          <el-input v-model="form.beginPoint" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.end')">
          <el-input v-model="form.endPoint" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.walking_distance')">
          <el-input v-model="form.walk" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.estimated_time')">
          <el-input v-model="form.estimateTime" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.Facilities_along_way')">
          <el-input v-model="form.along" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.multiplayer_game')">
          <el-input v-model="form.multiplayer" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.player_age')">
          <el-input v-model="form.playerAge" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.transportation')">
          <el-input v-model="form.transportation" size="large" />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.gameLanguage')">
          <el-select v-model="form.gameLanguage">
            <el-option label="繁体中文" value="繁体中文" />
            <el-option label="简体中文" value="简体中文" />
            <el-option label="English" value="English" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.gameCategory')">
          <el-select v-model="form.gameClass">
            <el-option label="单人角色剧本" value="单人角色剧本" />
            <el-option label="多人角色剧本" value="多人角色剧本" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.tag')">
          <el-select
            v-model="form.tips"
            multiple
            filterable
            allow-create
            multiple-limit="5"
            default-first-option
            placeholder="请选择作品标签"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.difficulty')">
          <div class="demo-rate-block">
            <el-rate v-model="form.difficulty" />
          </div>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.playTime')">
          <el-input-number
            v-model="form.playTime"
            :min="10"
            :max="120"
            :step="10"
          />
        </el-form-item>
        <el-alert
          title="封面图最佳比例为4:3"
          type="warning"
          :center="true"
          :closable="false"
        />
        <el-form-item :label="$t('edit.cover.gameCover')">
          <el-upload
            class="avatar-uploader"
            :action="UpdateApi"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :limit="1"
            :file-list="fileList"
            :disabled="allowUpload"
          >
            <el-image
              :src="form.gameCover"
              v-if="form.gameCover"
              class="avatar"
              alt=""
              :fit="'contain'"
            >
              <template #error>
                <div class="image-slot">
                  <el-icon><icon-picture /></el-icon>
                </div>
              </template>
            </el-image>
            <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="allowUpload">
          <el-button type="warning" @click="clearImage">{{
            $t("settings.clearImg")
          }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.slideshow')">
          <VueDraggable ref="el" v-model="fileList2" class="content">
            <div
              v-for="(item, index) in fileList2"
              :key="item.id"
              class="lunBo"
            >
              <el-image
                :src="item.url"
                :fit="'contain'"
                class="elImg"
              ></el-image>
              <span class="clearImg" @click="clearImage2(index)">删除图片</span>
            </div>
          </VueDraggable>
          <el-upload
            :file-list="fileList2"
            :action="UpdateApi"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload2"
            :show-file-list="false"
            list-type="picture-card"
            style="margin-top: 10px; margin-left: 10px"
          >
            <el-icon class="avatar-uploader-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('edit.cover.gameDescription')">
          <el-input
            v-model="form.gameDesc"
            type="textarea"
            size="large"
            rows="10"
            show-word-limit
            maxlength="400"
          />
        </el-form-item>
        <el-form-item :label="$t('edit.cover.research_characteristics')">
          <el-input
            v-model="form.features"
            type="textarea"
            size="large"
            rows="10"
            show-word-limit
            maxlength="400"
          />
        </el-form-item>
      </el-form>
      <div class="zhanwei4"></div>
    </div>
    <dvi class="coverSetting_right">
      <h2>{{ $t("edit.cover.titleApp") }}</h2>
      <div class="animate__animated animate__fadeIn app">
        <div class="app_icon">
          <p>
            <el-icon size="20" color="#fff"><ArrowLeft /></el-icon>
          </p>
          <p>
            <el-icon size="20" color="#fff"><More /></el-icon>
          </p>
        </div>
        <div class="app_cover">
          <el-image
            style="height: 100%"
            :src="
              form.gameCover == ''
                ? 'https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493'
                : form.gameCover
            "
            fit="cover"
          />
        </div>
        <div class="author_info">
          <p>{{ form.gameTitle == "" ? "游戏标题" : form.gameTitle }}</p>
          <p><span></span><span></span></p>
          <p></p>
        </div>
        <div class="about">
          <h3>{{ $t("edit.cover.app1") }}</h3>
          <p>
            <span
              ><el-icon size="15"><QuestionFilled /></el-icon></span
            ><span>{{ $t("edit.cover.app2") }}</span
            ><span><el-rate v-model="form.difficulty" size="default" /></span>
          </p>
          <p>
            <span
              ><el-icon size="15"><AlarmClock /></el-icon></span
            ><span>{{ $t("edit.cover.app3") }}：</span
            ><span>{{ form.playTime }}分钟</span>
          </p>
          <p>
            <span
              ><el-icon size="15"><Location /></el-icon></span
            ><span>{{ $t("edit.cover.app4") }}</span>
          </p>
        </div>
        <div class="introduce">
          <h3>{{ $t("edit.cover.app5") }}</h3>
          <p>{{ form.gameDesc == "" ? "游戏介绍" : form.gameDesc }}</p>
        </div>
      </div>
    </dvi>
  </div>
  <div class="zhanwei3"></div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import {
  Right,
  FolderChecked,
  Plus,
  More,
  ArrowLeft,
  AlarmClock,
  QuestionFilled,
  Location,
  Picture as IconPicture,
  EditPen,
  DeleteFilled,
} from "@element-plus/icons-vue";
import { UploadProps } from "element-plus";
import { ElNotification } from "element-plus";
import { vDraggable, VueDraggable } from "vue-draggable-plus";

export default defineComponent({
  name: "App",
  data(): any {
    return {
      form: {
        openHour: "",
        belongId: "",
        createTime: "",
        beginPoint: "",
        endPoint: "",
        walk: "",
        estimateTime: "",
        along: "",
        multiplayer: "",
        playerAge: "",
        difficulty: 3,
        gameClass: "",
        gameCover: "",
        gameDesc: "",
        features: "",
        gameLanguage: "",
        gameLevelId: "",
        gameTitle: "",
        author: "",
        id: "",
        playTime: 1,
        status: 0,
        updateTime: null,
        startTime: "",
        experienceTime: "",
        begin: "",
        transportation: "",
        tips: [],
        carousel: [],
      },
      fileList: [],
      fileList2: [],
      dialogImageUrl: "",
      dialogVisible: false,
      options: [
        {
          value: "庙宇",
          label: "庙宇",
        },
        {
          value: "澳门",
          label: "澳门",
        },
        {
          value: "广州",
          label: "广州",
        },
        {
          value: "佛山",
          label: "佛山",
        },
        {
          value: "深圳",
          label: "深圳",
        },
        {
          value: "博物馆",
          label: "博物馆",
        },
        {
          value: "非遗",
          label: "非遗",
        },
        {
          value: "环保",
          label: "环保",
        },
        {
          value: "动物园",
          label: "动物园",
        },
        {
          value: "植物园",
          label: "植物园",
        },
        {
          value: "科学馆",
          label: "科学馆",
        },
        {
          value: "历史街区",
          label: "历史街区",
        },
        {
          value: "红色主题",
          label: "红色主题",
        },
      ],
    };
  },
  components: {
    DeleteFilled,
    EditPen,
    Right,
    FolderChecked,
    Plus,
    More,
    ArrowLeft,
    AlarmClock,
    QuestionFilled,
    Location,
    IconPicture,
    VueDraggable,
  },
  directives: {
    draggable: vDraggable,
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return this.form.gameCover !== "";
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    counter(newVal: number, oldVal: number) {
      console.log(`Counter changed from ${oldVal} to ${newVal}`);
    },
    message(newVal: string, oldVal: string) {
      console.log(`Message changed from "${oldVal}" to "${newVal}"`);
    },
  },
  mounted() {
    if (this.$route.params.id != 0) {
      const game = this.$store.state.game.games.find((item: any) => {
        return item.id == this.$route.params.id;
      });

      if (game != undefined && game.gameLevelId != "") {
        this.form = game;

        if (this.form.carousel != null) {
          this.fileList2 = this.form.carousel.split(",").map((url, index) => {
            return { url, uid: index, name: `file-${index}` };
          });
        }

        this.$forceUpdate();
        this.fetchGameList(game.gameLevelId);
      }
    }
  },
  methods: {
    handleSave() {
      const { updateTime, ...formWithoutUpdateTime } = this.form;

      formWithoutUpdateTime.tips = JSON.stringify(formWithoutUpdateTime.tips);
      formWithoutUpdateTime.carousel = this.fileList2
        .map((item) => {
          return item.url;
        })
        .join(",");

      // console.log(formWithoutUpdateTime);
      this.$store
        .dispatch("game/updateGame", { gameBean: formWithoutUpdateTime })
        .then((res: any) => {})
        .catch(() => {});
    },
    fetchGameList(gameLevelId: string) {
      this.$store
        .dispatch("game/getGameLevelList", { gameLevelId: gameLevelId })
        .then((res: any) => {})
        .catch((err: any) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // Display uploaded avatar
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.gameCover = reader.result as string;
      };

      return true;
    },
    beforeAvatarUpload2(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      return this.fileList2.length < 5;
    },
    handleAvatarSuccess(response: any) {
      this.form.gameCover = response.data.returnFileUrl;
    },
    handleAvatarError2(response: any) {
      console.log(response);
    },
    handleAvatarSuccess2(response: any) {
      if (response.code == 200) {
        // 将文件 URL 包装成对象
        this.fileList2.push({
          url: response.data.returnFileUrl, // 图片的 URL
          uid: Date.now(), // 唯一标识符，可使用时间戳
          name: "图片名称", // 可以使用实际文件名或自定义
          status: "finished", // 状态为完成上传
        });
      }
    },
    clearImage2(index: number) {
      // 删除对应索引的对象
      this.fileList2.splice(index, 1);
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },

    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
    clearImage() {
      this.form.gameCover = "";
      this.fileList = [];
    },
    onUpdate() {},
  },
});
</script>

<style lang="less" scoped>
@import "@/static/less/cover.less";

.content {
  width: 40vw;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  .lunBo {
    width: 150px;
    height: 150px;
    margin-left: 10px;
    margin-top: 10px;
    position: relative;

    .elImg {
      width: 100%;
      height: 100%;
      transition: opacity 0.3s ease; /* 添加一个平滑的过渡效果 */
    }

    .clearImg {
      position: absolute;
      left: 30%;
      top: 40%;
      z-index: 100;
      display: none;
      color: #000;
    }

    &:hover {
      .elImg {
        opacity: 0.5;
      }

      .clearImg {
        display: block;
        font-weight: bold;
      }
    }
  }
}
</style>
